/* eslint-disable no-undef */
import angular from 'angular';

import * as InviteLibrela from '../modules/experiencelibrela';
import * as InviteSolensia from '../modules/experiencesolensia';

/**
 * @ngdoc function
 * @name myConsultApp.controller:iepDashboardController
 * @description
 * # iepDashboardController
 * Controller of the myConsultApp
 */
angular
  .module('myConsultApp')
  .controller(
    'iepDashboardController',
    ($scope, crumble, $location, $filter, $timeout, utilities, utilitiesV2, MediaService) => {
      // if user is not org user, redirect to admin interface
      if ($scope.isAdminUser || $scope.isSuperUser) {
        $location.path('/admin');
      } else {
        $scope.crumble = crumble;
        crumble.update();
      }

      /*
       *  Scope Variables
       *
       */

      $scope.product = $location.$$url.startsWith('/experience-librela') ? 'librela' : 'solensia';
      $scope.species = $scope.product === 'solensia' ? 'cat' : 'dog';
      $scope.introDropdownOpened = true;
      $scope.participantSorterOpened = false;
      $scope.selectedParticipantFilter = null;
      $scope.selectedParticipantSorter = null;
      $scope.clientEmailCopied = false;
      $scope.reminderEmailCopied = false;
      $scope.inviteEmailSubject =
        $scope.product === 'librela'
          ? InviteLibrela.generateInviteEmailSubject()
          : InviteSolensia.generateInviteEmailSubject();
      $scope.inviteEmailBody =
        $scope.product === 'librela'
          ? InviteLibrela.generateInviteEmailBody($scope.currentOrganization)
          : InviteSolensia.generateInviteEmailBody($scope.currentOrganization);
      $scope.inviteEmailBodyCopy =
        $scope.product === 'librela'
          ? InviteLibrela.generateInviteEmailBody($scope.currentOrganization, false)
          : InviteSolensia.generateInviteEmailBody($scope.currentOrganization, false);
      $scope.reminderEmailSubject =
        $scope.product === 'librela'
          ? InviteLibrela.generateReminderEmailSubject()
          : InviteSolensia.generateReminderEmailSubject();
      $scope.reminderEmailBody =
        $scope.product === 'librela'
          ? InviteLibrela.generateReminderEmailBody($scope.currentOrganization)
          : InviteSolensia.generateReminderEmailBody($scope.currentOrganization);
      $scope.reminderEmailBodyCopy =
        $scope.product === 'librela'
          ? InviteLibrela.generateReminderEmailBody($scope.currentOrganization, false)
          : InviteSolensia.generateReminderEmailBody($scope.currentOrganization, false);
      $scope.participantData = [];

      $scope.columns = [
        { name: '', width: 315 },
        { name: '', width: 110 },
        { name: 'Initial Treatment Date', width: 250 },
        { name: 'Number of Videos', width: 250 },
        { name: 'Tracking Behavior', width: 250 },
      ];

      $scope.iepOrganization = $scope.isAdminUser ? '' : $scope.currentOrganization.id;
      $scope.mediaCategories = $scope.product === 'librela' ? '4' : '2';
      $scope.mediaTypes = null;
      $scope.mediaSearch = null;
      $scope.order = 'id';
      $scope.pageSize = 1000;
      $scope.petIds = [];
      $scope.showErrorModal = false;
      $scope.errorModalMessage = '';

      $scope.updateServerMedia = (id, settings) => {
        if (settings?.files?.extra_data) {
          settings.files.extra_data.medication = $scope.capitalize($scope.product);
          MediaService.setMediaInfo(id, settings).catch((err) => {
            console.warn(err);
          });
        }
      };

      $scope.getProductData = () => {
        // get all media for for this organization
        MediaService.getMedia(
          $scope.mediaSearch,
          null,
          null,
          $scope.mediaTypes,
          $scope.mediaCategories,
          $scope.iepOrganization,
          $scope.order,
          $scope.pageSize,
        )
          .then(
            (media) => {
              const findPetIndex = (id) => {
                return $scope.participantData.findIndex((element) => element.id === id);
              };
              if (media.length === 0) {
                return;
              }
              media.files.forEach((file) => {
                if (
                  file.pets[0]?.is_active &&
                  file?.extra_data?.medication === $scope.capitalize($scope.product)
                ) {
                  // if pet not in list yet, add it
                  if (!$scope.petIds.contains(file.pets[0].id)) {
                    $scope.petIds.push(file.pets[0].id);
                    let pet = file.pets[0];
                    pet.files = [];
                    pet.owner = file.user;
                    if (file?.extra_data?.is_parent === true) {
                      pet.parentVideo = file;
                    }
                    $scope.participantData.push(pet);
                  }
                  // assign file to correct position in pet.files array
                  const index = findPetIndex(file.pets[0].id);
                  const treatment = file?.extra_data?.treatment;
                  if (treatment >= 0) {
                    let arr = $scope.participantData[index].files[treatment];
                    arr = arr ? [...arr, file] : [file];
                    $scope.participantData[index].files[treatment] = utilitiesV2.sortArrayByDate({
                      array: arr,
                      sortField: 'created',
                    });
                  }
                }
              });
            },
            (err) => {
              $scope.showErrorModal = true;
              $scope.errorModalMessage = err.data.media.errors[0];
            },
          )
          .then(() => {
            $scope.participantData.forEach((arr) => {
              if (arr?.parentVideo) return;
              const filteredFiles = arr.files.filter((file) => {
                return file !== null;
              });
              const video = filteredFiles[0][0];
              const id = video.id;
              const settings = {
                files: {
                  extra_data: {
                    is_parent: true,
                  },
                },
              };
              $scope.updateServerMedia(id, settings);
            });
          });
      };

      $scope.viewTreatmentDetail = (id) => {
        $location.path(`/experience-${$scope.product}/${id}`);
      };

      $scope.changeButtonText = (text, delay) => {
        $timeout(() => {
          return text;
        }, delay);
      };

      $scope.inviteClient = () => {
        utilities.submitTelemetry({
          event: 'e_inviteClient',
          eventAction: 'Invite A Client',
          orgId: $scope.currentOrganization.id,
        });
      };

      $scope.copyClientEmail = () => {
        $scope.clientEmailCopied = true;
      };

      $scope.copyReminderEmail = () => {
        $scope.reminderEmailCopied = true;
      };

      $scope.closeModal = () => {
        $scope.showErrorModal = false;
      };

      $scope.showSettings = () => {
        utilities.submitTelemetry({
          event: 'e_buttonClick',
          eventAction: 'Settings',
          orgId: $scope.currentOrganization.id,
        });
      };

      $scope.toggleIntroDropdown = () => {
        $scope.introDropdownOpened = !$scope.introDropdownOpened;
      };

      $scope.getNumberVideos = (obj) => {
        let count = 0;
        obj.files.forEach((element) => {
          element.forEach(() => {
            count += 1;
          });
        });
        return count;
      };

      $scope.getParentVideo = (arr) => {
        if (!arr || !arr?.files) return;
        if (arr?.parentVideo) {
          return arr.parentVideo;
        }
      };

      $scope.getInitialTreatmentDate = (obj) => {
        return (
          $filter('date')(
            $scope.getParentVideo(obj)?.extra_data?.initial_treatment_date,
            'MM/dd/yyyy',
          ) || '-'
        );
      };

      $scope.getTrackingBehavior = (obj) => {
        return $scope.getParentVideo(obj)?.extra_data?.tracking_behavior;
      };

      /*
       *
       * Main
       *
       */

      $scope.getProductData();

      /*
       *
       *  Watchers
       *
       */

      $scope.$watch('clientEmailCopied', (newVal) => {
        if (newVal === true) {
          $timeout(() => {
            $scope.clientEmailCopied = false;
          }, 1000);
        }
      });

      $scope.$watch('reminderEmailCopied', (newVal) => {
        if (newVal === true) {
          $timeout(() => {
            $scope.reminderEmailCopied = false;
          }, 1000);
        }
      });
    },
  );
